import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';

@Component({
  selector: 'app-resme-target',
  templateUrl: './resme-target.component.html',
  styleUrls: ['./resme-target.component.css'],
})
export class ResmeTargetComponent {
  @Input() formGroup!: FormGroup;
  @Output() next = new EventEmitter<void>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (this.targets.length === 0) {
      this.addTarget();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.targets.updateValueAndValidity();
    }, 100);
  }

  get targets(): FormArray {
    return this.formGroup.get('target') as FormArray;
  }

  addTarget() {
    // No validators - all fields are optional
    const targetGroup = this.fb.group({
      name: [''],
      description: [''],
    });
    this.targets.push(targetGroup);
  }

  removeTarget(index: number): void {
    if (this.targets.length > 1) {
      this.targets.removeAt(index);
    }
  }

  onNext() {
    // Resume target is completely optional
    if (this.targets.length === 0) {
      this.next.emit();
      return;
    }

    // Remove completely empty targets before proceeding
    for (let i = this.targets.length - 1; i >= 0; i--) {
      const group = this.targets.at(i) as FormGroup;
      const name = group.get('name')?.value;
      const description = group.get('description')?.value;

      // Remove if both fields are empty
      const isEmpty =
        (!name || name.trim() === '') &&
        (!description || description.trim() === '');

      if (isEmpty) {
        this.targets.removeAt(i);
      }
    }

    // Proceed regardless - target section is optional
    this.next.emit();
  }
}
